import { EAppColors } from '@/types/app-colors.types';
import { EPaletteModes } from '@/types/theme-packs.types';

const getAppBackgroundVariable = (themeMode: EPaletteModes): EAppColors => {
  // Determine the app background variable based on the theme mode
  return themeMode === EPaletteModes.Light ? EAppColors.backgroundLightMode : EAppColors.backgroundDarkMode;
};

export default getAppBackgroundVariable;
